export default "__VITE_ASSET__DAc1qBgC__"